(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('stockZones', {
        templateUrl: 'views/components/views/stockZones/stockZones.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['stateService', 'utilityService', 'stockZonesService', 'logisticService', 'rememberService', 'ttGridFactory', function (stateService, utilityService, stockZonesService, logisticService, rememberService, ttGridFactory) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;

            let variableNames = {
                businessco_no: '',
                stockplace_id: '',
                bg_stockzones: ''
            };

            let setMainView = function (id) {
                vm.model.bgStockZones.selected = vm.model.setting.bg_stockzones = id;
            }

            vm.model = {
                bgStockZones: {
                    selected: 'ZONES',
                    buttons: [
                        { id: 'ZONES', label: 'bg_stockzones_zones', color: 'primary', onClick: { click: setMainView, id: 'ZONES' } },
                        { id: 'STOCKLOCATIONS', label: 'bg_stockzones_stocklocations', color: 'primary', onClick: { click: setMainView, id: 'STOCKLOCATIONS' } },
                        { id: 'WAREHOUSES', label: 'bg_stockzones_warehouses', color: 'primary', onClick: { click: setMainView, id: 'WAREHOUSES' } },
                    ]
                },
                setting: {},
                selectListCompanies: [],
                selectListStockPlaces: [],
                sorting: false,
                retrieving: false
            };

            vm.grid = new ttGridFactory({
                rememberId: 'w_stockzones_stocklocations_grid',
                kendo: {
                    height: '100%',
                    sortable: true,
                    aggregate: true,
                    pager: false,
                    selectable: false,
                    filterable: false
                }
            }).setToolbar({ wrapping: true });

            vm.whGrid = new ttGridFactory({
                rememberId: 'w_stockzones_stocklocations_wh_grid',
                kendo: {
                    height: '100%',
                    sortable: true,
                    aggregate: true,
                    pager: false,
                    selectable: false,
                    filterable: false
                }
            })
                .setToolbar({ wrapping: true })
                .setOptionFunc((data) => whOptionfunc(data.data));

            function whOptionfunc(data) {
                if (data.func && data.func === 'OnCellClose') {
                    //console.log('optionfunc - OnCellClose');
                    //console.dir(data);
                    data['rdata']['stockplace_id'] = vm.model.setting.stockplace_id;
                    stockZonesService.saveWarehouse(data['rdata']);
                    loadSzGrid();
                }
            }

            vm.szGrid = new ttGridFactory({
                rememberId: 'w_stockzones_stocklocations_sz_grid',
                kendo: {
                    height: '100%',
                    sortable: true,
                    aggregate: true,
                    pager: false,
                    selectable: false,
                    filterable: false
                }
            })
                .setToolbar({ wrapping: true })
                .setCustomToolbarButtons([{
                    name: 'stockzones_create_new',
                    text: 'stockzones_create_new',
                    func: () => {
                        stateService.go('stockzone', {
                            stockplace_id: vm.model.setting.stockplace_id,
                            stockzone_keyno: '0'
                        });
                    },
                    icon: 'fa-plus',
                    cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
                    translate: true
                }])
                .setOptionFunc((data) => szOptionfunc(data.data));

            function szOptionfunc(data) {
                if (data.func && data.func === 'OnCellClose') {
                    //console.log('optionfunc - OnCellClose');
                    //console.dir(data);
                    data['rdata']['stockplace_id'] = vm.model.setting.stockplace_id;
                    stockZonesService.saveStockZone(data['rdata']);
                    loadSzGrid();
                }
            }

            // #endregion VARIABLES & DEFINITIONS

            // #region LOAD PROCEDURE FUNCTION CALLS

            async function loadSetting() {
                vm.model.setting = (await stockZonesService.getStockZonesSetting())[0];
                
                setMainView(vm.model.setting.bg_stockzones);

                return Promise.all([
                    loadStocks()
                ]).then(() => {
                    loadGrid();
                    loadWhGrid();
                    loadSzGrid();

                    Promise.resolve();
                });

                return Promise;
            }

            async function loadCompanies() {
                vm.model.selectListCompanies = await logisticService.listCompanies();
            }

            async function loadStocks() {
                if (utilityService.validateParmsValue(vm.model.setting.businessco_no, true) !== true) return;

                return vm.model.selectListStockPlaces = await logisticService.listStocks({ businessco_no: vm.model.setting.businessco_no });
            }

            // #endregion LOAD PROCEDURE FUNCTION CALLS

            // #region GRID PROCEDURE FUNCTION CALLS

            async function loadSzGrid() {
                vm.szGrid.dataTask.loadData = {
                    method: 2571,
                    parameters: { stockplace_id: vm.model.setting.stockplace_id }
                };

                vm.model.szGridReady = true;

                if (vm.szGrid.gridfunc !== null) vm.szGrid.gridfunc.read();
            }

            async function loadGrid() {
                vm.grid.dataTask.loadData = {
                    method: 2643,
                    parameters: { stockplace_id: vm.model.setting.stockplace_id }
                };

                vm.model.gridReady = true;

                if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
            }

            async function loadWhGrid() {
                vm.whGrid.dataTask.loadData = {
                    method: 2542,
                    parameters: { stockplace_id: vm.model.setting.stockplace_id }
                };

                vm.model.whGridReady = true;

                if (vm.whGrid.gridfunc !== null) vm.whGrid.gridfunc.read();
            }

            // #endregion GRID PROCEDURE FUNCTION CALLS

            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

            function rememberFunc(id) {
                Object.keys(variableNames).forEach((key) => {
                    switch (key) {
                        case 'businessco_no':
                        case 'stockplace_id':
                        case 'bg_stockzones':
                            variableNames[key] = stateService.getCurrentName() + '.' + key;
                            break;
                        default:
                            variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
                            break;
                    }
                });

                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

                let variableValue = null;

                switch (id) {
                    case 'businessco_no':
                    case 'stockplace_id':
                    case 'bg_stockzones':
                        if (utilityService.validateParmsValue(vm.model.setting[id]) !== true) return;

                        variableValue = vm.model.setting[id];
                        break;
                    default:
                        break;
                }

                return rememberService.remember(variableNames[id], variableValue);
            }

            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

            // #region BUTTON GROUP SINGLE FUNCTION

            vm.selectBgStockZones = function (item) {
                vm.model.bgStockZones.selected = item;
                vm.model.setting.bg_stockzones = vm.model.bgStockZones.selected;

                rememberFunc('bg_stockzones');
            }

            // #endregion BUTTON GROUP SINGLE FUNCTION

            // #region SHOW PROGRESSBAR DIALOGUE BOX FUNCTION

            vm.sortChanges = function () {
                vm.model.sorting = true;
                let sort = [];

                if (Object.hasOwn(vm.grid.gridfunc, 'getColumnState')) {
                    const sortedColumns = vm.grid.gridfunc.getColumnState().filter((columnState) => !!columnState.sort);

                    sort = sortedColumns.map((columnState) => ({
                        dir: columnState.sort,
                        field: columnState.colId
                    }));
                } else {
                    sort = vm.grid.gridfunc.getDataSource().sort();
                }

                let dirtyRows = vm.grid.gridfunc.getIsSelectedRows();
                let query = new kendo.data.Query(dirtyRows);
                let sortedRows = query.sort(sort).data;
                let startNumber = parseInt(vm.model.setting.sorting_nbr_start);
                
                angular.forEach(sortedRows, function (item) {
                    if (item.is_selected === true) {
                        item.sortorder = startNumber;

                        if (startNumber !== 0) {
                            startNumber = startNumber + 1;
                        }
                    }

                    vm.grid.gridfunc.redrawRow(item);
                });

                vm.model.sorting = false;
                vm.grid.gridfunc.refresh();
            }

            // #endregion SHOW PROGRESSBAR DIALOGUE BOX FUNCTION

            vm.retrieveDefaultLocations = function () {
                vm.model.retrieving = true;

                vm.grid.gridfunc.read().then(function () {
                    vm.model.retrieving = false;
                });
            }

            // #region FIELD CHANGE MULTI FUNCTIONS

            // #region FIELD CHANGE MULTI FUNCTIONS

            vm.onChanged = function (value, id) {
                switch (id) {
                    case 'businessco_no':
                        if (utilityService.validateWatchValue(value, vm.model.setting.businessco_no) !== true) return;

                        vm.model.setting.businessco_no = value;

                        if (utilityService.validateParmsValue(vm.model.setting.businessco_no) !== true) return;

                        Promise.all([
                            rememberFunc('businessco_no')
                        ]).then(() => {
                            loadStocks();
                            Promise.resolve();
                        });
                        break;
                    case 'stockplace_id':
                        if (utilityService.validateWatchValue(value, vm.model.setting.stockplace_id) !== true) return;

                        vm.model.setting.stockplace_id = value;

                        if (utilityService.validateParmsValue(vm.model.setting.stockplace_id, true) !== true) return;

                        Promise.all([
                            rememberFunc('stockplace_id')
                        ]).then(() => {
                            if (vm.model.bgStockZones.selected === 'ZONES') {
                                loadSzGrid();
                            } else if (vm.model.bgStockZones.selected === 'STOCKLOCATIONS') {
                                loadGrid();
                            } else if (vm.model.bgStockZones.selected === 'WAREHOUSES') {
                                loadWhGrid();
                            }

                            Promise.resolve();
                        });
                        break;
                    default:
                        utilityService.setValueToVariable(value);
                        break;
                }
            };

            // #endregion FIELD CHANGE MULTI FUNCTIONS

            // #region ON INIT FUNCTION

            vm.$onInit = function () {
                loadSetting();
                loadCompanies();
            }

            // #endregion ON INIT FUNCTION

        }]
    });
})();
